const steps = [
  {
    number: "01",
    icon: "ri-cursor-line",
    title: "QR Türünü Seçin",
    desc: "URL, vCard, WiFi, PDF ve daha fazlası arasından ihtiyacınıza uygun QR kod türünü seçin.",
    color: "bg-blue-50 text-blue-600",
  },
  {
    number: "02",
    icon: "ri-palette-line",
    title: "Tasarımı Özelleştirin",
    desc: "Renk, logo ve çerçeve ekleyerek markanıza özel benzersiz bir QR kod tasarımı oluşturun.",
    color: "bg-sky-50 text-sky-600",
  },
  {
    number: "03",
    icon: "ri-download-cloud-line",
    title: "İndirin & Paylaşın",
    desc: "PNG, SVG veya PDF formatında yüksek çözünürlüklü QR kodunuzu indirin ve hemen kullanmaya başlayın.",
    color: "bg-indigo-50 text-indigo-600",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-blue-600 text-sm font-semibold uppercase tracking-widest">Nasıl Çalışır?</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
            3 Basit Adımda QR Kodunuzu Oluşturun
          </h2>
          <p className="text-slate-500 mt-4 max-w-xl mx-auto">
            Teknik bilgiye gerek yok. Dakikalar içinde profesyonel QR kodlarınızı hazırlayın.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector lines */}
          <div className="hidden md:block absolute top-12 left-1/3 right-1/3 h-0.5 bg-gradient-to-r from-blue-200 to-indigo-200"></div>

          {steps.map((step, idx) => (
            <div key={idx} className="relative flex flex-col items-center text-center group">
              <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-6 ${step.color} transition-transform group-hover:scale-110`}>
                <i className={`${step.icon} text-3xl`}></i>
              </div>
              <div className="absolute top-0 right-1/2 translate-x-1/2 -translate-y-2 text-xs font-bold text-slate-300">
                {step.number}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3">{step.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed max-w-xs">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}